/**
 * PATH: apps/hr/src/pages/leave/components/TimesheetsTable.tsx
 * PURPOSE: Timesheet days table component
 */

import { cn, formatDate } from '../../../lib/utils'
import type { TimesheetDayApi } from './types'

const statusStyles: Record<string, string> = {
  draft: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  submitted: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  approved: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
  rejected: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
}

export function TimesheetsTable({ days }: { days: TimesheetDayApi[] }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50">
            <th className="text-left text-xs font-medium text-slate-500 uppercase tracking-wider py-3 px-4">Worker</th>
            <th className="text-left text-xs font-medium text-slate-500 uppercase tracking-wider py-3 px-4">Date</th>
            <th className="text-left text-xs font-medium text-slate-500 uppercase tracking-wider py-3 px-4">Hours</th>
            <th className="text-left text-xs font-medium text-slate-500 uppercase tracking-wider py-3 px-4">Entries</th>
            <th className="text-left text-xs font-medium text-slate-500 uppercase tracking-wider py-3 px-4">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
          {days.map((d) => (
            <tr key={d.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
              <td className="py-3 px-4 text-sm font-medium text-slate-900 dark:text-white">{d.worker_name}</td>
              <td className="py-3 px-4 text-sm text-slate-600 dark:text-slate-400">
                {formatDate(d.work_date, { day: 'numeric', month: 'short', year: 'numeric' })}
              </td>
              <td className="py-3 px-4 text-sm text-slate-600 dark:text-slate-400 tabular-nums">{d.total_hours.toFixed(2)}</td>
              <td className="py-3 px-4 text-sm text-slate-600 dark:text-slate-400 tabular-nums">{d.entry_count}</td>
              <td className="py-3 px-4">
                <span className={cn('px-2.5 py-1 rounded-full text-xs font-medium capitalize', statusStyles[d.status] || 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300')}>
                  {d.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {days.length === 0 && (
        <div className="py-12 text-center text-sm text-slate-400">No timesheet days found</div>
      )}
    </div>
  )
}
